var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00392 21.243L21.4671 2.98694C22.1551 2.30663 22.1551 1.20363 21.4671 0.523317L21.4511 0.507524C20.7631 -0.172786 19.6476 -0.172786 18.9596 0.507525L0.496382 18.7636C-0.191646 19.4439 -0.191648 20.5469 0.49638 21.2272L0.512352 21.243C1.20038 21.9233 2.3159 21.9233 3.00392 21.243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4668 39.4991L21.4827 39.4833C22.1708 38.803 22.1708 37.7 21.4827 37.0197L3.01955 18.7636C2.33152 18.0833 1.216 18.0833 0.527974 18.7636L0.512002 18.7794C-0.176026 19.4597 -0.176024 20.5627 0.512004 21.243L18.9752 39.4991C19.6632 40.1794 20.7787 40.1794 21.4668 39.4991Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 40,
    fill: "white",
    transform: "translate(22 40) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrowBack.06e667ddb08380e6a2642f8d471e1a3a.svg";
export { ForwardRef as ReactComponent };